import AdjuntarArchivosModel from "./adjuntar-archivos.model";

export default class ObtenerInformacionAdjuntosModel {

	public documentosMultiples: Array<any>;
	public adjunto: AdjuntarArchivosModel;
	public categoria: number = 4; 

}